export const selectItems = state => state.items;
export const selectIsFetching = state => state.isFetching;
export const selectDidFail = state => state.didFail;
export const selectQuery = state => state.query;
